import { ObjectView } from "./object";
import { OBJECT_REGISTRY } from "../utils/object-registry";
import { Type } from 'class-transformer';
import { Screen } from "../screen";
import tag from "@/model/tag";


export class GroupView extends ObjectView {
  
@Type(() => ObjectView, {
    discriminator: {
      property: '__type',
      subTypes: [
        ...Object.entries(OBJECT_REGISTRY).map(([name, value]) => ({
          value,
          name
        })),
        { value: GroupView, name: 'group' }
      ]
    }
  })
  objects: ObjectView[];
  public isUpdate(): boolean {
    let upd = false
    this.objects.forEach((obj => {
      if (obj.isUpdate()) {
        upd = true;
      }
    }))
    return upd;
  }
  public setUpdate(u: boolean): void {
    this.objects.forEach((obj => {
      obj.setUpdate(u)
    }))
  }
  public executeOnCreateScripts(screen: Screen) {
    this.objects.forEach((obj => {
      obj.executeOnCreateScripts(screen)
    }))
  }
  public executeOnDataChangeScripts(screen: Screen, tag: tag) {
    this.objects.forEach((obj => {
      obj.executeOnDataChangeScripts(screen, tag)
    }))
  }
  public executeOnDestroyScripts(screen: Screen) {
    this.objects.forEach((obj => {
      obj.executeOnDestroyScripts(screen)
    }))
  }
  public CheckFunctions(screen: Screen, object: ObjectView) {
    super.CheckFunctions(screen, object);
    this.objects.forEach((obj => {
      obj.screen = screen.name;
      obj.CheckFunctions(screen, obj);
    }))

  }
  public drawObject(): void {
    super.initObject();
    this.objects.forEach((obj => {

      obj.name = obj.name.replace("{screen}", this.screen)
      obj.name = obj.name.replace("{group}", this.name)

      obj.initLayer(this.layer)
      obj.drawObject();
      obj.group = this;
      obj.tagnames.forEach((tagname => {
        if (!this.tagnames.includes(tagname))
          this.tagnames.push(tagname);
      }))
      this.node.add(obj.rotatednode);
    }))
  }
  public hasPropertyWithBadTag(): boolean {
    for (const obj of this.objects) {
        if (obj.hasPropertyWithBadTag()) {
            return true;
        }
    }
    return false;
}
  public hasPropertyWithUncertainTag(): boolean {
   for (const obj of this.objects) {
        if (obj.hasPropertyWithUncertainTag()) {
            return true;
        }
    }
    return false;
  }

}